module.exports = __webpack_public_path__ + "media/assets/CHECK-thick-teal.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/CHECK-thick-teal.svg
// module id = 22
// module chunks = 0